import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import './index.css';
import './App.css';
import App from './App';

import { ThemeProvider, CssBaseline, StyledEngineProvider } from '@mui/material';
import theme from './theme';


// Axios 전역 설정 (쿠키 자동 포함)
axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StyledEngineProvider injectFirst>      {/* (선택) MUI 스타일 우선순위 확보 */}
    <ThemeProvider theme={theme}>         {/* 🔹 테마 주입 */}
      <CssBaseline />                     {/* (선택) 브라우저 기본 스타일 리셋 */}
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </StyledEngineProvider>
);
